import { createRoot } from "react-dom/client";

import "./index.css";
import App from "./app/App";

// Global ResizeObserver error suppression
window.addEventListener("error", (e) => {
  if (
    e.message &&
    e.message.includes(
      "ResizeObserver loop completed with undelivered notifications",
    )
  ) {
    e.stopImmediatePropagation();
    return false;
  }
});

// Also handle unhandled promise rejections that might contain ResizeObserver errors
window.addEventListener("unhandledrejection", (e) => {
  if (
    e.reason &&
    e.reason.message &&
    e.reason.message.includes("ResizeObserver")
  ) {
    e.preventDefault();
    return false;
  }
});

createRoot(document.getElementById("root")!).render(<App />);
